import styles from './style.postcss';

import React from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import { Icon } from 'omni-common-ui';
import PropTypes from 'prop-types';

const withoutClassName = (props) => {
  const newProps = Object.assign({}, props);
  delete newProps.className;
  return newProps;
};

const ArrowLink = (props) => <Link className={classnames(
      styles.ArrowLink, props.className)}
    draggable={false}
    {...withoutClassName(props)}>
  {props.children}
  <Icon id="arrow-right" className={styles.ArrowLink_arrow} />
</Link>;

ArrowLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  to: PropTypes.string,
};

export default ArrowLink;



// WEBPACK FOOTER //
// ./components/ArrowLink/index.jsx